<template>
  <div id="linkWrapper" v-html="content" class="contentHTML"></div>
</template>
<script>
export default {
  name: "ContentHTML",
  props: ['content'],
  data: () => ({
  }),
  computed: {},
  methods: {},
  mounted() {
    var anchors = document.querySelectorAll('#linkWrapper a');
    for (var i=0; i<anchors.length; i++){
      if (anchors[i].hostname != window.location.hostname) {
          anchors[i].setAttribute('target', '_blank');
      }
    }
  },
};
</script>
